'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _CellGallery = require('./CellGallery.scss');var _CellGallery2 = _interopRequireDefault(_CellGallery);
var _cellGalleryParams = require('./cellGalleryParams');var _cellGalleryParams2 = _interopRequireDefault(_cellGalleryParams);
var _images_placeholder = require('../../../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _iconPdf = require('../../../../../../static/icons/icon-pdf.png');var _iconPdf2 = _interopRequireDefault(_iconPdf);
var _modifyImageLink = require('../../../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../../../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CellGallery = function (_Component) {_inherits(CellGallery, _Component);function CellGallery() {var _temp, _this, _ret;_classCallCheck(this, CellGallery);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      activeIndex: 0 }, _this.

















    resizeThrottler = function () {
      _this.swiperRef.swiper.resize.resizeHandler();
    }, _this.

    handleTransitionEnd = function () {
      var activeIndex = (0, _get2.default)(_this.swiperRef, 'swiper.activeIndex');
      if (Number.isInteger(activeIndex)) {
        _this.setState({ activeIndex: activeIndex });
      }
    }, _this.

    renderGalleryItem = function (item, idx) {
      var shouldLoadImage = idx >= _this.state.activeIndex - 1 && idx <= _this.state.activeIndex + 1;
      var handleClick = function handleClick(evt) {return evt.stopPropagation();};

      if (item.raw) {
        return (
          _react2.default.createElement('div', {
              className: _CellGallery2.default.raw,
              key: item.thumbnail },

            _react2.default.createElement('img', {
              alt: '',
              src: _iconPdf2.default }),

            _react2.default.createElement('a', { href: item.thumbnail, onClick: handleClick }, item.name)));


      }

      return (
        _react2.default.createElement('div', {
            className: _CellGallery2.default.image,
            key: item.thumbnail },

          _react2.default.createElement('img', {
            alt: '',
            srcSet: '\n            ' + (
            (0, _modifyImageLink2.default)(item.thumbnail, _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default) + ' 350w,\n            ' + (
            (0, _modifyImageLink2.default)(item.thumbnail, _constants.imageModifierTypes.GALLERY_THUMBNAIL_MOBILE) || _images_placeholder2.default) + ' 600w\n          ',

            sizes: '(max-width: 767px) 600px, (min-width: 768px) 350px',
            src: (0, _modifyImageLink2.default)(item.thumbnail, _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default })));



    }, _temp), _possibleConstructorReturn(_this, _ret);}CellGallery.prototype.componentDidMount = function componentDidMount() {window.addEventListener('orientationchange', this.resizeThrottler, false);};CellGallery.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {var isRtlChanged = newProps.isRtl !== this.props.isRtl;var isImagesChanged = newProps.images.length !== this.props.images.length;return isRtlChanged || isImagesChanged || newProps.withoutLoop;};CellGallery.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('orientationchange', this.resizeThrottler, false);};CellGallery.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,images = _props.images,isRtl = _props.isRtl,isLazy = _props.isLazy,withoutLoop = _props.withoutLoop,withoutPagination = _props.withoutPagination;
    var gallerySwiperParams = (0, _cellGalleryParams2.default)({
      className: 'cellGalleryArrow',
      isMobile: true,
      isRtl: isRtl,
      isLazy: isLazy,
      withoutLoop: withoutLoop });


    var params = Object.assign({},
    gallerySwiperParams, {
      rtl: isRtl,
      noSwiping: true,
      initialSlide: this.state.activeIndex,
      loop: !withoutLoop,
      on: {
        slideChangeTransitionEnd: this.handleTransitionEnd },

      pagination: !withoutPagination && {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true },

      preloadImages: false,
      lazy: { loadOnTransitionStart: true } });


    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_CellGallery2.default.galleryWrapper, this.props.className) },
        this.props.withoutRealEstateSlider ?
        this.renderGalleryItem(images[0]) :

        _react2.default.createElement(_reactIdSwiper2.default, _extends({}, params, { ref: function ref(_ref) {_this2.swiperRef = _ref;} }),
          images.map(function (item, idx) {return _this2.renderGalleryItem(item, idx);}))));




  };return CellGallery;}(_react.Component);exports.default = CellGallery;


CellGallery.propTypes = {
  images: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  withoutLoop: _propTypes2.default.bool,
  withoutPagination: _propTypes2.default.bool,
  isLazy: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  withoutRealEstateSlider: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellGallery/CellGallery.js
// module id = 2771
// module chunks = 0